import { getAccessToken } from '@/contexts/auth/token-storage'

const getDefaultHeaders = () => {
  const token = getAccessToken()

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'x-fintalk-origin': 'studio/backoffice',
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  return headers
}

export { getDefaultHeaders }
